export default function IconArrow({ fillColor }) {
  return (
    <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26.7027 12.7709H52.2446V38.3127" stroke={fillColor} stroke-width="4"/>
    <path d="M52.2447 12.7709L12.771 52.2446" stroke={fillColor} stroke-width="4"/>
    </svg>
  );
}
